import { useState } from "react";
import SubmitTicket from "./SubmitTicket";
import MyTickets from "./MyTickets";
import "../../styles/org-management.css";

const TABS = [
  { id: "submit", label: "Submit", icon: "✍️" },
  { id: "my-tickets", label: "My Requests", icon: "📋" },
] as const;

type TabId = (typeof TABS)[number]["id"];

export default function FeedbackPage() {
  const [activeTab, setActiveTab] = useState<TabId>("submit");

  return (
    <div>
      <h1>Feedback & Support</h1>
      <p className="page-subtitle">
        Report bugs or request features — we track every submission
      </p>

      <div className="org-mgmt-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`org-mgmt-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
            type="button"
          >
            <span>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "submit" && <SubmitTicket onSubmitted={() => setActiveTab("my-tickets")} />}
      {activeTab === "my-tickets" && <MyTickets />}
    </div>
  );
}
